var map = {
	"./news-6-1.jpg": 58902,
	"./news-6-10.jpg": 12876,
	"./news-6-2.jpg": 48481,
	"./news-6-3.jpg": 70436,
	"./news-6-4.jpg": 48399,
	"./news-6-5.jpg": 80466,
	"./news-6-6.jpg": 90365,
	"./news-6-7.jpg": 34784,
	"./news-6-8.jpg": 40251,
	"./news-6-9.jpg": 85470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30798;